export default "__VITE_ASSET__CZozUorU__"